export interface Vendor {
  id: string;
  name: string;
  contactPerson: string;
  email: string;
  phone: string;
  gstin: string;
  address: string;
  city: string;
  state: string;
  pincode: string;
  paymentTerms: string;
  accountNumber?: string;
  bankName?: string;
  ifscCode?: string;
  vendorType: string;
  createdAt: string;
  updatedAt: string;
  userId: string;
  pendingAmount?: number; // Total amount pending to be paid
  partialPayments?: VendorPayment[]; // Record of partial payments
  isActive?: boolean;
}

export interface VendorPayment {
  id: string;
  vendorId?: string;
  amount: number;
  date: string;
  paymentMethod: string;
  reference: string;
  notes?: string;
  purchaseIds: string[]; // The purchase invoices this payment is applied to
  createdAt: string;
}

export const PAYMENT_TERMS = [
  'Immediate',
  '7 Days',
  '15 Days',
  '30 Days',
  '45 Days',
  '60 Days'
];

export const VENDOR_TYPES = [
  'Product Supplier',
  'Service Provider',
  'Contractor',
  'Utility',
  'Consultant',
  'Other'
];

export const PAYMENT_METHODS = [
  'Cash',
  'Bank Transfer',
  'UPI',
  'Credit Card',
  'Debit Card',
  'Check',
  'Digital Wallet'
]; 